import { ConfigProvider as AntdConfigProvider, theme as antdTheme } from 'antd'
import React from 'react'
import { GeckoTheme, useGeckoTheme } from 'styles/GeckoTheme'

export const AntdConfigImpl: React.FC<{
  children: React.ReactNode
}> = ({ children }) => {
  const { theme } = useGeckoTheme()

  return (
    <AntdConfigProvider
      theme={{
        algorithm: antdTheme.darkAlgorithm,
        token: {
          colorIcon: theme.forecast.icon1,
          colorPrimary: theme.colors.grayscale_alternate['200'],
          colorPrimaryHover: theme.forecast.text4,
          colorText: theme.forecast.text1,
          colorBgContainer: theme.forecast.background1,
          colorBgElevated: theme.forecast.background2_5,
          colorBgBase: theme.forecast.background2,
          colorBorder: theme.forecast.background3,
          colorPrimaryBorder: theme.forecast.background4,
          colorBorderSecondary: theme.forecast.background3,
          colorTextPlaceholder: theme.forecast.background4,
          colorFill: theme.forecast.background3,
          colorFillSecondary: theme.forecast.background4,
          colorFillContent: theme.forecast.background4,
          colorPrimaryBg: theme.forecast.background2,
          fontFamily: GeckoTheme.fontFamily.manrope,
        },
        components: {
          Spin: {
            colorPrimary: GeckoTheme.colors.highVis,
          },
          InputNumber: {
            colorPrimary: GeckoTheme.colors.highVis,
            handleBg: 'transparent',
            handleActiveBg: 'rgba(63,73,0,1)',
            handleBorderColor: GeckoTheme.colors.grayscale_alternate['200'],
            handleHoverColor: GeckoTheme.colors.highVis,
            hoverBorderColor: GeckoTheme.colors.grayscale['300'],
            activeBorderColor: GeckoTheme.colors.grayscale['400'],
            borderRadius: 4,
            activeShadow: '0 0 0 2px rgba(255, 255, 255, .1)',
            colorBorder: GeckoTheme.colors.grayscale_alternate['200'],
          },
          Slider: {
            railSize: 6,
            railBg: GeckoTheme.colors.grayscale_alternate['200'],
            railHoverBg: GeckoTheme.colors.grayscale['500'],
            trackBg: 'rgba(255, 255, 0, 0.5)',
            trackHoverBg: GeckoTheme.colors.highVis,
            dotBorderColor: 'white',
            dotActiveBorderColor: GeckoTheme.colors.highVis,
            handleColor: 'rgba(255, 255, 0, 1)',
            handleActiveColor: GeckoTheme.colors.highVis,
            colorPrimaryBorderHover: GeckoTheme.colors.highVis,
          },
          Tabs: {
            colorBorderSecondary: GeckoTheme.forecast.border,
            verticalItemPadding: '0px',
            verticalItemMargin: '0px',
            colorPrimary: GeckoTheme.colors.highVis,
          },
          DatePicker: {
            colorPrimary: GeckoTheme.colors.highVis,
          },
          Message: {
            contentBg: GeckoTheme.colors.gray['800'],
          },
        },
      }}>
      {children}
    </AntdConfigProvider>
  )
}
